import React, { useEffect } from "react";
import Script from "next/script";
import { withErrorBoundary } from "react-error-boundary";
import { useInView } from "react-intersection-observer";

import { Logger } from "lib/logger";
import { trackProductReviewViewed } from "utils/gtm";
import { useLocale } from "hooks";

import { useSegment } from "tracking";

import styles from "./reviews.legacy.module.css";
import * as vanillaStyles from "./Reviews.css";

const localeMap = { "en-GB": "en_GB", "en-US": "en_US" };

const ReviewsComponent: React.FC<{
  children?: React.ReactNode;
  sku: string;
}> = ({ sku, children }) => {
  const locale = useLocale();
  const lang = localeMap[locale];

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0
  });

  const { track } = useSegment();

  useEffect(() => {
    if (inView) {
      trackProductReviewViewed();

      track({
        event: "Page Element Viewed",
        properties: {
          module_content: "PDP Reviews"
        }
      });
    }
  }, [track, inView]);

  return (
    <div id="reviews" className={`${styles.reviews} ${vanillaStyles.reviews}`}>
      <Script
        strategy="lazyOnload"
        type="text/javascript"
        src={`https://apps.bazaarvoice.com/deployments/beautypie/main_v2/${process.env.NEXT_PUBLIC_BV_ENVIRONMENT}/${lang}/bv.js`}
      />

      <div className={vanillaStyles.reviewsWrapper}>
        <div
          ref={ref}
          data-testid="product-reviews-grid"
          id="product-reviews-grid"
          data-bv-show="reviews"
          data-bv-product-id={sku}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export const Reviews = withErrorBoundary(ReviewsComponent, {
  fallback: <div />,
  onError(error) {
    Logger.warn(`Reviews failed to load. ${error}`);
  }
});
